import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Input from "../../Common/Forms/Input";
import ButtonPrimary from "../../Common/Buttons/ButtonPrimary";
import toast from "react-hot-toast";
import BaseCard from "../../Common/Cards/BaseCard";
import { globalStores, useGlobalStore } from "../../api/globalStores";
import Avatar from "../../Common/Avatars/Avatar";
import { Child } from "../../api/child";
import Modal from "../../Common/Utility/Modal";
import { wrap } from "module";
import { supabase } from "../../api/supabase/client";

export default observer(AccountResetScreen);

function AccountResetScreen() {
  return (
    <>
      {/* DESKTOP VIEW */}

      <div className="hidden bg-brij-Default h-screen lg:flex relative bg-hill_children bg-contain bg-no-repeat bg-bottom backdrop-opacity-50 w-full">
        <div className="p-14 flex w-full justify-center z-10">
          <div className="flex-col flex justify-center">
            <BaseCard>
              <div className="inline-flex flex-col gap-3 w-full">
                <AccountReset />
              </div>
            </BaseCard>
          </div>
        </div>
      </div>

      {/* MOBILE VIEW */}

      <div className="lg:hidden flex flex-col gap-2 items-center bg-brij-Default h-screen relative bg-playground bg-contain bg-no-repeat bg-bottom backdrop-opacity-50 w-full p-8 justify-start overflow-y-scroll">
        <div className="flex flex-col gap-3 w-full">
          <AccountReset />
        </div>
      </div>
    </>
  );
}

const AccountReset = observer(() => {
  const navigate = useNavigate();
  const globalStore = useGlobalStore();
  const [newPass, setNewPass] = useState<string>("");
  const [confirmPass, setConfirmPass] = useState("");
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const parsedHash = new URLSearchParams(location.hash.substring(1));
    const newAccessToken = parsedHash.get("access_token");

    if (newAccessToken) {
      setAccessToken(newAccessToken);
      return;
    }
    // Fallback: supabase-js v2 may have stripped the recovery hash during
    // its in-URL session detection before this page mounted. The recovery
    // session is still active, so use it to gate the form.
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.access_token) {
        setAccessToken(session.access_token);
      }
    });
  }, [location.hash]);

  const updatePassword = async () => {
    if (newPass !== confirmPass) {
      throw new Error("Passwords do not match!");
    }

    if (!accessToken) {
      throw new Error("Invalid access token!");
    }

    const { error } = await supabase.auth.updateUser({
      password: newPass,
    });

    if (error) throw error;

    navigate("/");
  };

  return (
    <>
      <div className="inline-flex items-center justify-center">
        <div className="flex h-44 w-[134px] flex-col items-center justify-center gap-[18px] overflow-clip rounded-xl p-3">
          <div className="h-20 w-20">
            <Avatar large icon={"bear"} active={false} />
          </div>
          <div className="flex flex-col items-center justify-center gap-1">
            {/* <p className="h-5 w-[110px] text-center font-['Poppins'] text-lg font-medium leading-[1.35] text-[rgba(109,109,109,1)]">
            </p> */}
            <p className="text-center font-['Poppins'] text-sm leading-[1.4] text-[rgba(109,109,109,1)]">
              Password Reset
            </p>
          </div>
        </div>
      </div>
      <Input
        onChange={(passCode) => {
          setNewPass(passCode);
        }}
        type="password"
        placeholder="New Password"
      />
      <Input
        onChange={(passCode) => {
          setConfirmPass(passCode);
        }}
        type="password"
        placeholder="Confirm New Password"
      />
      <ButtonPrimary
        onClick={() => {
          toast.promise(updatePassword(), {
            loading: "Updating Password",
            error: (e: any) => e.message,
            success: "Password Updated!",
          });
        }}
      >
        Submit
      </ButtonPrimary>
      <div className="flex justify-center py-4 px-2">
        <button
          onClick={() => navigate("/parent/login")}
          className="text-brij-DarkGrey hover:text-brij-Black"
        >
          BACK
        </button>
      </div>
    </>
  );
});
